import React from 'react';

import { Card } from 'antd';

import PublicLayout from 'v2/components/Shared/PublicLayout';

const TokenExpired = () => {
  return (
    <PublicLayout>
      <Card>
        <div className='text-center'>
          <p className='text-base font-medium'>Esse link está expirado ou inválido!</p>
          <p className='text-sm font-medium'>Solicite um novo link para criação da conta bancária.</p>
        </div>
      </Card>
    </PublicLayout>
  );
};

export default TokenExpired;
